<template>
  <div class="page">
    <div class="artice">
      <div class="u-flex bread u-row-between">
        <div class="container" style="display: flex;align-items: center;justify-content: space-between">
          <span> 文档首页>{{ article ? article.title : '正文' }}</span>
          <span>发布时间：{{ article ? formatTime(article.createtime) : '-' }}</span>
        </div>


      </div>
      <div class="container">
        <div class="content" v-if="article">
          <h3 class="u-flex">{{ article.title }}</h3>
          <div v-html="article.content"></div>
        </div>
        <div v-else>
          加载中...
        </div>
      </div>
      <div class="u-flex u-row-between btn">
        <div class="prev" @click="onPrev">
          <i class="el-icon-back"></i>
          <span>上一篇：{{ prevTitle || '无了' }}</span>
        </div>
        <div class="next" @click="onNext">
          <span>下一篇：{{ nextTitle || '无了' }}</span>
          <i class="el-icon-right"></i>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import {getFaqDetail} from '@/api';

export default {
  name: 'FaqDetail',
  data() {
    return {
      article: null,
      prevTitle: '',
      nextTitle: '',
      cid: this.$route.query.cid,
      id: this.$route.query.id,
      documentList: [], // 文档列表
      currentIndex: 0, // 当前文档在列表中的索引
	  doc_ind:0
    }
  },


  created() {
    this.cid = this.$route.query.cid ? this.$route.query.cid : 0
    this.id = this.$route.query.id ? this.$route.query.id : 0
    this.getDocumentList()
  },
  methods: {
    // 获取文档列表并设置当前文档
    getDocumentList() {
      this.$api.document.getDocumentList({cid: this.cid}).then(res => {
        this.documentList = res.data || []
        this.setCurrentDocument()
      }).catch(err => {
        console.error('获取文档列表失败:', err)
        this.$message.error('获取文档列表失败')
      })
    },

    // 根据ID设置当前文档
    setCurrentDocument() {
      if (this.documentList.length === 0) {
        this.article = null
        return
      }

      // 根据ID查找当前文档
      const targetId = parseInt(this.id)
      this.currentIndex = this.documentList.findIndex(doc => doc.id === targetId)

      // 如果没找到指定ID，默认显示第一个
      if (this.currentIndex === -1) {
        this.currentIndex = 0
      }

      // 设置当前文档
      this.article = this.documentList[this.currentIndex]

      // 设置上一篇/下一篇标题
      this.setNavigationTitles()
    },

    // 设置导航标题
    setNavigationTitles() {
      if (this.documentList.length === 0) {
        this.prevTitle = ''
        this.nextTitle = ''
        return
      }

      // 上一篇
      if (this.currentIndex > 0) {
        this.prevTitle = this.documentList[this.currentIndex - 1].title
      } else {
        this.prevTitle = ''
      }

      // 下一篇
      if (this.currentIndex < this.documentList.length - 1) {
        this.nextTitle = this.documentList[this.currentIndex + 1].title
      } else {
        this.nextTitle = ''
      }
    },

    onPrev() {
		if(this.doc_ind==0){
			this.prevTitle = ''
			return;
		};
		this.article=this.documentList[this.doc_ind-1];
		this.doc_ind--;
		
      // 跳转到上一篇文章
      // if (this.currentIndex > 0) {
      //   this.currentIndex--
      //   this.article = this.documentList[this.currentIndex]
      //   this.setNavigationTitles()

      //   // 更新URL参数
      //   this.$router.push({
      //     path: this.$route.path,
      //     query: {
      //       cid: this.cid,
      //       id: this.article.id
      //     }
      //   })
      // }
    },
    onNext() {
		console.log('onnext');
		if(this.doc_ind>=this.documentList.length){
			this.prevTitle = '';
			return;
		};
		this.article=this.documentList[this.doc_ind+1];
		this.doc_ind++;
		
      // 跳转到下一篇文章
      // if (this.currentIndex < this.documentList.length - 1) {
      //   this.currentIndex++
      //   this.article = this.documentList[this.currentIndex]
      //   this.setNavigationTitles()

      //   // 更新URL参数
      //   this.$router.push({
      //     path: this.$route.path,
      //     query: {
      //       cid: this.cid,
      //       id: this.article.id
      //     }
      //   })
      // } else {

      // }
    },
    onComplete() {
      // 通用完成回调方法
      console.log('操作完成');
    },
    formatTime(ts) {
      if (!ts || ts === null || ts === undefined) return '-';
      // 支持10位和13位时间戳
      const t = ts.toString().length === 10 ? ts * 1000 : ts;
      const d = new Date(t);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
  },
}
</script>

<style scoped>
.page{
  width: 100%;
  background-color: #dfe2e9;
  padding-top: 100px; /* 为固定菜单留出空间 */
  padding-bottom: 20px;
}
.artice {
  background: #fff;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

}


.content {
  margin: 30px auto;

  padding: 40px;
}

.content h3 {
  color: #333;
  font-size: 24px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 30px;
  line-height: 1.4;
}

.content p {
  margin: 16px 0;
  line-height: 1.7;
  color: #555;
  font-size: 15px;
  text-align: left;
}

.btn {
  background: #fff;
  margin: 40px auto;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prev,
.next {
  color: #666;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 15px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  background: #f5f5f5;
  min-width: 120px;
  justify-content: center;
}

.prev:hover,
.next:hover {
  background: #007bff;
  color: #fff;
}

.prev span {
  margin-left: 8px;
}

.next span {
  margin-right: 8px;
}

.prev i,
.next i {
  font-size: 14px;
  transition: transform 0.2s ease;
}

.prev:hover i {
  transform: translateX(-2px);
}

.next:hover i {
  transform: translateX(2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }

  .content {
    margin: 20px auto;
    padding: 30px 20px;
  }

  .content h3 {
    font-size: 24px;
  }

  .btn {
    margin: 20px auto;
    padding: 20px 25px;
  }

  .prev,
  .next {
    font-size: 14px;
    padding: 10px 15px;
  }
}
</style>
